<template>
  <div class="flex flex-col h-screen w-screen">
      <div class="pt-5 pl-5">
        <img src='@/assets/logo-n/logo.png'
            srcset="@/assets/logo-n/logo.png 1x,
                    @/assets/logo-n/logo@2x.png 2x,
                    @/assets/logo-n/logo@3x.png 3x,
                    @/assets/logo-n/logo@4x.png 4x"
            class="h-10"
                    />
      </div> <!-- <header> -->
      <div class="flex-grow">
        <router-view class="h-full" />
      </div> <!-- <content> flex bg-red h-full -->
      <Footer class="p-3" /> <!-- <footer> -->
  </div>
</template>

<script>
import Footer from '@/components/layout/Footer.vue';

export default {
    name: 'blankLayout',
    props: {
        msg: String
    },
    components: {
        Footer
    }
};
</script>


<style scoped lang="scss">
</style>
